import ConfigService from "@/utilities/services/entities/ConfigService";
import {ErrorLocationType} from "@/utilities/enums/Enums";
import {useGlobalStore} from "@/stores/GlobalStore";

// Helper function to always keep the serviceConfig in the global store up to date,
// needed because it is otherwise hard to ensure, that the correct default values,
// can be sent to any object that needs the config-default.
export const updateServiceConfig = async ()=>{
    (useGlobalStore()).settings.serviceConfig = await (new ConfigService()).get(ErrorLocationType.table)
}